module.exports = __webpack_public_path__ + "static/media/devtern.48eab739.png";